import { httpClient } from "../../../../../utils/HttpClient";
import { ApiEndpoint } from "../../../../../utils/ApiEndpoint";

export const getRCSReportSmryByPartners = async ({ token, data = {} }) => {
  const response = await httpClient(
    "post",
    ApiEndpoint + "reports/rcssmyrpartner",
    data,
    token,
  );


  return response.data;
};
